const KEY_ICON_MAP = {
  total_count: 'HashIcon',
  certificate_issued: 'AwardIcon',
  completed: 'CheckCircleIcon',
  pending: 'ClockIcon',
  total_pending: 'ClockIcon',
  late_requests: 'AlertTriangleIcon',
  in_turn: 'RefreshCwIcon',
  in_progress: 'PlayCircleIcon',
  waiting_for_inspection: 'EyeIcon',
  inspector_completed_data: 'ClipboardIcon',
  in_review: 'SearchIcon',
  review_completed: 'CheckCircleIcon',
  inspection_is_completed: 'CheckCircleIcon',
  canceled: 'XCircleIcon',
  Not_Found: 'SearchIcon',
  second_review: 'EyeIcon',
  Send_back_to_Client: 'ArrowLeftIcon',
  total_load: 'ActivityIcon',
  No_Action_Taken: 'MinusCircleIcon',
  Completed_payment_by_facility: 'CreditCardIcon',
  Waiting_To_Recieve_Request_By_CB: 'InboxIcon',
  Follow_comments_of_the_request_study: 'MessageCircleIcon',
  Processing_Request_by_Authorized_Body: 'SettingsIcon',
  Request_study_and_Recommendations_Review: 'FileTextIcon',
  Revising_the_Recommendations_of_the_Review_Committee_: 'Edit3Icon',
  Escalate_request_due_to_failure_to_follow_request_study_comments:
    'TrendingUpIcon',
  Rejected_To_Receive_Request_By_CB: 'XCircleIcon',
  Waiting_receipt_of_the_request_from_conformity_assessment_body_side:
    'InboxIcon',
  Pending_payment_by_the_Facility: 'CreditCardIcon',
  Waiting_For_Creating_Bill: 'FilePlusIcon',
  Waiting_for_conformity_assessment_body_decision: 'HelpCircleIcon',
  Applicant_Modified_for_Third_Party: 'Edit3Icon',
  default: 'BarChart2Icon',
}

export default KEY_ICON_MAP
